var path = 'src/app/components/common/field/field.template.html';
var html = "<div ng-transclude></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;